import React from 'react';
import { KeyboardBackspace, NavigateBefore, NavigateNext } from '@mui/icons-material'
import { Box, Button, Typography, useTheme, alpha } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ControlBar = (props) => {
  const { tutor } = props
  const teachers = useSelector(state => state.search.results)
  const index = teachers.findIndex(teacher => teacher._id === tutor._id)
  const navigate = useNavigate()
  const location = useLocation()
  const backToSearch = () => {
    navigate('/search' + location.search);
  }

  const theme = useTheme()
  
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      mb: 3
    }}>
      <Button
        onClick={backToSearch}
        startIcon={<KeyboardBackspace />}
        sx={{
          color: theme.palette.text.secondary,
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.08)
          }
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Back to Search
        </Typography>
      </Button>
      
      {index > -1 && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          {index > 0 && (
            <Button
              onClick={() => navigate(`/tutor/${teachers[index - 1]._id}`)}
              startIcon={<NavigateBefore />}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderColor: theme.palette.divider,
                color: theme.palette.text.secondary,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08)
                }
              }}
            >
              Previous
            </Button>
          )}
          {index < teachers.length - 1 && (
            <Button
              onClick={() => navigate(`/tutor/${teachers[index + 1]._id}`)}
              endIcon={<NavigateNext />}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderColor: theme.palette.divider,
                color: theme.palette.text.secondary,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  color: theme.palette.primary.main,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08)
                }
              }}
            >
              Next
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ControlBar;
